export default "__VITE_ASSET__9K2fKfLo__"